import { Component, OnInit } from '@angular/core';
import { ButtonComponent } from '../shared/button/button.component';
import { IconTypes } from '../shared/icon/icon.component';
import { NgIf } from '@angular/common';
import { ApiService } from '../core/services/api.service';
import { SpinnerComponent } from '../shared/spinner/spinner.component';
import { IssueDetailsComponent } from '../issue-details/issue-details.component';
import { ActivatedRoute, Router } from '@angular/router';
import { JiraIssue } from '../core/models/jira-issue.model';
import { JiraApiService } from '../core/services/jira-api.service';
import { ObsidianTokenDTO } from '../core/models/obsidian-token.model';
import { MessageComponent } from "../shared/message/message.component";

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  imports: [SpinnerComponent, ButtonComponent, NgIf, IssueDetailsComponent, MessageComponent],
})
export class HomeComponent implements OnInit {
  issueKey = '';
  jiraIssue?: JiraIssue;
  loaded = false;
  token?: ObsidianTokenDTO;

  constructor(
    private apiService: ApiService,
    private jiraApiService: JiraApiService,
    private route: ActivatedRoute,
    private router: Router,
  ) {}

  async ngOnInit(): Promise<void> {
    this.issueKey = this.route.snapshot.paramMap.get('issueKey') || '';
    // await this.loadMe();
    // this.generateUrl();
    await this.loadJiraIssue();
    await this.loadToken();
    this.loaded = true;
  }

  get IconTypes() {
    return IconTypes;
  }

  goToTokenPage(): void {
    this.router.navigate(['app', 'obsidian-token', this.issueKey], { queryParamsHandling: 'preserve' });
    // this.router.navigate(['/app/obsidian-token'], { queryParamsHandling: 'preserve' });
  }

  private async loadJiraIssue(): Promise<void> {
    try {
      this.jiraIssue = await this.jiraApiService.issue(this.issueKey || '');
    } catch (error) {
      console.error('Cannot fetch issue due to: ', error);
    }
  }

  private async loadToken(): Promise<void> {
    try {
      this.token = await this.apiService.get<ObsidianTokenDTO>('/tokens');
      console.log('--- this.', this.token);
    } catch (error) {
      console.error('Cannot get obsidian token on home due to:', error);
    }
  }
}
